var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#EDFDF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3928_131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.126,
    y: 34.7305,
    width: 25.1497,
    height: 25.1497,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6396 25.0243C48.1023 22.7515 51.8977 22.7515 54.3604 25.0243C55.8345 26.3848 57.8591 26.9793 59.8347 26.6317C63.1352 26.0511 66.3281 28.1031 67.1711 31.3465C67.6756 33.288 69.0574 34.8827 70.9073 35.6584C73.9978 36.9543 75.5745 40.4068 74.53 43.5911C73.9049 45.4971 74.2052 47.5857 75.342 49.2384C77.2413 51.9995 76.7011 55.7563 74.1009 57.8704C72.5445 59.1359 71.6679 61.0553 71.7308 63.0602C71.8358 66.4098 69.3503 69.2782 66.0199 69.6509C64.0264 69.8741 62.2513 71.0149 61.2202 72.7355C59.4977 75.6101 55.8559 76.6794 52.8527 75.1924C51.055 74.3024 48.945 74.3024 47.1473 75.1924C44.1441 76.6794 40.5023 75.6101 38.7798 72.7355C37.7487 71.0149 35.9736 69.8741 33.9801 69.6509C30.6497 69.2782 28.1642 66.4098 28.2692 63.0602C28.3321 61.0553 27.4555 59.1359 25.8991 57.8704C23.2989 55.7563 22.7587 51.9995 24.658 49.2384C25.7948 47.5857 26.0951 45.4971 25.47 43.5911C24.4255 40.4068 26.0022 36.9543 29.0927 35.6584C30.9426 34.8827 32.3244 33.288 32.8289 31.3465C33.6719 28.1031 36.8648 26.0511 40.1653 26.6317C42.1409 26.9793 44.1655 26.3848 45.6396 25.0243Z",
    fill: "#0BB77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 49.5L44.5 57L62.5 42",
    stroke: "white",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3928_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.663b3ae52c96144cd2aa53557da115a7.svg";
export { ForwardRef as ReactComponent };